export default __webpack_public_path__ + "static/media/31_tag_pet-friendly.462ae7e5.svg";